import { InjectionToken } from '@angular/core';

import { ActionReducerMap } from '@ngrx/store';

import { StoreSelector } from './store-selector.const';
import * as fromConnection from './connection-sign/connection-sign.reducers';
import { pendingTasksReducer } from '../../../store/pendingTasks';
import { openedTasksReducer } from '../../../store/openedTasks';
import { userReducer } from '../../../store/user';
import { userPrefsReducer } from '../../../store/userPrefs';
import { contextHelpReducer } from '../../../store/contextHelpReducer';
import { elemVisibilityStateReducer } from '../../../store/elemVisibilityState';
import { sessionRefreshReducer } from '../../../store/sessionRefreshState';

export interface State {
  [StoreSelector.Connection]: fromConnection.ConnectionState;
}

export const reducers = new InjectionToken<ActionReducerMap<State>>(
  'NgRxReducers',
  {
    factory: () => {
      return {
        //TODO: refactor:migrate-to: New Implementation
        pendingTasks: pendingTasksReducer,
        openedTasks: openedTasksReducer,
        user: userReducer,
        userPrefs: userPrefsReducer,
        contextHelp: contextHelpReducer,
        elemVisibilityState: elemVisibilityStateReducer,
        sessionRefresh: sessionRefreshReducer,
        //New Implementation
        [StoreSelector.Connection]: fromConnection.reducer,
      } as ActionReducerMap<State>;
    },
  }
);
